import React, { useState } from "react";
import { Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { Bars } from "react-loader-spinner";

import DraggableField from "../DraggableField/DraggableField";
import {
  openRulesNav,
  closeRulesNav,
  handleRulesFieldClick
} from "./RulesPanel.utils";

import styles from "../../../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.module.css";

interface RulesPanelProps {
  rulesOpen: boolean;
  setRulesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setContentBlocksOpen: React.Dispatch<React.SetStateAction<boolean>>;
  templateFieldRulesList: string[];
  templateFieldRulesRowData: {
    RuleName: string;
    TemplateRuleId: number;
    SelectedFieldLabel: string;
    SelectedFieldValue: string;
  }[];
  setSelectedRule: (rule: any) => void;
  setAddRulesModalShow: React.Dispatch<React.SetStateAction<boolean>>;
  refreshRules: boolean;
  forwizard?: boolean;
}

const RulesPanel: React.FC<RulesPanelProps> = ({
  rulesOpen,
  setRulesOpen,
  setContentBlocksOpen,
  templateFieldRulesList,
  templateFieldRulesRowData,
  setSelectedRule,
  setAddRulesModalShow,
  refreshRules,
  forwizard
}) => {
  const [searchText, setSearchText] = useState("");

  const filteredList = templateFieldRulesList.filter(name =>
    name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <div
        className={
          rulesOpen ? "myrules-button-wrapper rules-active" : "myrules-button-wrapper"
        }
        style={{ display: forwizard ? "none" : "" }}
      >
        <Button
          className="flex-column-center-center myrules-button"
          onClick={
            !rulesOpen
              ? () => openRulesNav(setRulesOpen, setContentBlocksOpen)
              : () => closeRulesNav(setRulesOpen)
          }
        >
          <Icon.BuildingFillGear
            style={{ color: "gray", fontSize: 16, marginBottom: 10, marginTop: 5 }}
          />
          <p>Rules</p>
        </Button>
      </div>

      <div
        id="myrules"
        className={rulesOpen ? "myrules fields-section-active" : "myrules"}
      >
        <div className="myrules-content-wrapper">
          <div className="myrules-content">
            <div className={styles.dropdownSearchContainer}>
              <Icon.Search className={styles.searchIcon} />
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search field..."
                className={styles.dropdownSearch}
              />
            </div>

            {!refreshRules ? (
              <div className="rule-fields-column">
                {filteredList.map((name, index) => (
                  <DraggableField
                    key={index}
                    label={name}
                    value={name}
                    type="Rule"
                    handleBtnClick={() =>
                      handleRulesFieldClick(
                        name,
                        templateFieldRulesRowData,
                        setSelectedRule,
                        setAddRulesModalShow
                      )
                    }
                  />
                ))}
              </div>
            ) : (
              <div className="flex-row-center-center" style={{ marginTop: "20%" }}>
                <Bars
                  height="80"
                  width="80"
                  color="var(--theme1_primary)"
                  ariaLabel="bars-loading"
                  visible
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RulesPanel;
